import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetReferencePickerRegulationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReferencePickerRegulationsQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string, name: string }> };

export type GetReferencePickerRegulationsWithDocumentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReferencePickerRegulationsWithDocumentsQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string, name: string, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string }> }> };

export type GetSubscriptionReferenceDocumentQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetSubscriptionReferenceDocumentQuery = { __typename?: 'Query', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string } | null } | null };

export type GetReferencePickerRequirementsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReferencePickerRequirementsQuery = { __typename?: 'Query', requirements: Array<{ __typename?: 'Requirement', id: string, name: string }> };

export type GetReferencePickerRegulatoryDocumentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReferencePickerRegulatoryDocumentsQuery = { __typename?: 'Query', regulatoryDocuments?: { __typename?: 'RegulatoryDocumentsConnection', edges?: Array<{ __typename?: 'RegulatoryDocumentsEdge', node: { __typename?: 'RegulatoryDocument', id: string, name: string } }> | null } | null };

export type GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables = Types.Exact<{
  regulationId: Types.Scalars['ID'];
}>;


export type GetRegulatoryReferencePickerRegulatoryDocumentsQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus } }> } | null };

export type GetAssignSegmentReferencePickerDocumentsQueryVariables = Types.Exact<{
  regulationId: Types.Scalars['ID'];
}>;


export type GetAssignSegmentReferencePickerDocumentsQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus }> } | null };


export const GetReferencePickerRegulationsDocument = gql`
    query GetReferencePickerRegulations {
  regulations {
    id
    regulationNumber
    name
  }
}
    `;

/**
 * __useGetReferencePickerRegulationsQuery__
 *
 * To run a query within a React component, call `useGetReferencePickerRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencePickerRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencePickerRegulationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferencePickerRegulationsQuery(baseOptions?: Apollo.QueryHookOptions<GetReferencePickerRegulationsQuery, GetReferencePickerRegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencePickerRegulationsQuery, GetReferencePickerRegulationsQueryVariables>(GetReferencePickerRegulationsDocument, options);
      }
export function useGetReferencePickerRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencePickerRegulationsQuery, GetReferencePickerRegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencePickerRegulationsQuery, GetReferencePickerRegulationsQueryVariables>(GetReferencePickerRegulationsDocument, options);
        }
export type GetReferencePickerRegulationsQueryHookResult = ReturnType<typeof useGetReferencePickerRegulationsQuery>;
export type GetReferencePickerRegulationsLazyQueryHookResult = ReturnType<typeof useGetReferencePickerRegulationsLazyQuery>;
export type GetReferencePickerRegulationsQueryResult = Apollo.QueryResult<GetReferencePickerRegulationsQuery, GetReferencePickerRegulationsQueryVariables>;
export const GetReferencePickerRegulationsWithDocumentsDocument = gql`
    query GetReferencePickerRegulationsWithDocuments {
  regulations {
    id
    regulationNumber
    name
    regulatoryDocuments {
      id
      name
    }
  }
}
    `;

/**
 * __useGetReferencePickerRegulationsWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetReferencePickerRegulationsWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencePickerRegulationsWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencePickerRegulationsWithDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferencePickerRegulationsWithDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetReferencePickerRegulationsWithDocumentsQuery, GetReferencePickerRegulationsWithDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencePickerRegulationsWithDocumentsQuery, GetReferencePickerRegulationsWithDocumentsQueryVariables>(GetReferencePickerRegulationsWithDocumentsDocument, options);
      }
export function useGetReferencePickerRegulationsWithDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencePickerRegulationsWithDocumentsQuery, GetReferencePickerRegulationsWithDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencePickerRegulationsWithDocumentsQuery, GetReferencePickerRegulationsWithDocumentsQueryVariables>(GetReferencePickerRegulationsWithDocumentsDocument, options);
        }
export type GetReferencePickerRegulationsWithDocumentsQueryHookResult = ReturnType<typeof useGetReferencePickerRegulationsWithDocumentsQuery>;
export type GetReferencePickerRegulationsWithDocumentsLazyQueryHookResult = ReturnType<typeof useGetReferencePickerRegulationsWithDocumentsLazyQuery>;
export type GetReferencePickerRegulationsWithDocumentsQueryResult = Apollo.QueryResult<GetReferencePickerRegulationsWithDocumentsQuery, GetReferencePickerRegulationsWithDocumentsQueryVariables>;
export const GetSubscriptionReferenceDocumentDocument = gql`
    query GetSubscriptionReferenceDocument($id: ID!) {
  regulatoryDocument(id: $id) {
    id
    name
    regulation {
      id
      regulationNumber
    }
  }
}
    `;

/**
 * __useGetSubscriptionReferenceDocumentQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionReferenceDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionReferenceDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionReferenceDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionReferenceDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionReferenceDocumentQuery, GetSubscriptionReferenceDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionReferenceDocumentQuery, GetSubscriptionReferenceDocumentQueryVariables>(GetSubscriptionReferenceDocumentDocument, options);
      }
export function useGetSubscriptionReferenceDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionReferenceDocumentQuery, GetSubscriptionReferenceDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionReferenceDocumentQuery, GetSubscriptionReferenceDocumentQueryVariables>(GetSubscriptionReferenceDocumentDocument, options);
        }
export type GetSubscriptionReferenceDocumentQueryHookResult = ReturnType<typeof useGetSubscriptionReferenceDocumentQuery>;
export type GetSubscriptionReferenceDocumentLazyQueryHookResult = ReturnType<typeof useGetSubscriptionReferenceDocumentLazyQuery>;
export type GetSubscriptionReferenceDocumentQueryResult = Apollo.QueryResult<GetSubscriptionReferenceDocumentQuery, GetSubscriptionReferenceDocumentQueryVariables>;
export const GetReferencePickerRequirementsDocument = gql`
    query GetReferencePickerRequirements {
  requirements {
    id
    name
  }
}
    `;

/**
 * __useGetReferencePickerRequirementsQuery__
 *
 * To run a query within a React component, call `useGetReferencePickerRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencePickerRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencePickerRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferencePickerRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<GetReferencePickerRequirementsQuery, GetReferencePickerRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencePickerRequirementsQuery, GetReferencePickerRequirementsQueryVariables>(GetReferencePickerRequirementsDocument, options);
      }
export function useGetReferencePickerRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencePickerRequirementsQuery, GetReferencePickerRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencePickerRequirementsQuery, GetReferencePickerRequirementsQueryVariables>(GetReferencePickerRequirementsDocument, options);
        }
export type GetReferencePickerRequirementsQueryHookResult = ReturnType<typeof useGetReferencePickerRequirementsQuery>;
export type GetReferencePickerRequirementsLazyQueryHookResult = ReturnType<typeof useGetReferencePickerRequirementsLazyQuery>;
export type GetReferencePickerRequirementsQueryResult = Apollo.QueryResult<GetReferencePickerRequirementsQuery, GetReferencePickerRequirementsQueryVariables>;
export const GetReferencePickerRegulatoryDocumentsDocument = gql`
    query GetReferencePickerRegulatoryDocuments {
  regulatoryDocuments {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetReferencePickerRegulatoryDocumentsQuery__
 *
 * To run a query within a React component, call `useGetReferencePickerRegulatoryDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencePickerRegulatoryDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencePickerRegulatoryDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferencePickerRegulatoryDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetReferencePickerRegulatoryDocumentsQuery, GetReferencePickerRegulatoryDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencePickerRegulatoryDocumentsQuery, GetReferencePickerRegulatoryDocumentsQueryVariables>(GetReferencePickerRegulatoryDocumentsDocument, options);
      }
export function useGetReferencePickerRegulatoryDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencePickerRegulatoryDocumentsQuery, GetReferencePickerRegulatoryDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencePickerRegulatoryDocumentsQuery, GetReferencePickerRegulatoryDocumentsQueryVariables>(GetReferencePickerRegulatoryDocumentsDocument, options);
        }
export type GetReferencePickerRegulatoryDocumentsQueryHookResult = ReturnType<typeof useGetReferencePickerRegulatoryDocumentsQuery>;
export type GetReferencePickerRegulatoryDocumentsLazyQueryHookResult = ReturnType<typeof useGetReferencePickerRegulatoryDocumentsLazyQuery>;
export type GetReferencePickerRegulatoryDocumentsQueryResult = Apollo.QueryResult<GetReferencePickerRegulatoryDocumentsQuery, GetReferencePickerRegulatoryDocumentsQueryVariables>;
export const GetRegulatoryReferencePickerRegulatoryDocumentsDocument = gql`
    query GetRegulatoryReferencePickerRegulatoryDocuments($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    regulatoryDocuments {
      id
      name
      workflow {
        status
      }
    }
  }
}
    `;

/**
 * __useGetRegulatoryReferencePickerRegulatoryDocumentsQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryReferencePickerRegulatoryDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryReferencePickerRegulatoryDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryReferencePickerRegulatoryDocumentsQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetRegulatoryReferencePickerRegulatoryDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetRegulatoryReferencePickerRegulatoryDocumentsQuery, GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulatoryReferencePickerRegulatoryDocumentsQuery, GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables>(GetRegulatoryReferencePickerRegulatoryDocumentsDocument, options);
      }
export function useGetRegulatoryReferencePickerRegulatoryDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulatoryReferencePickerRegulatoryDocumentsQuery, GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulatoryReferencePickerRegulatoryDocumentsQuery, GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables>(GetRegulatoryReferencePickerRegulatoryDocumentsDocument, options);
        }
export type GetRegulatoryReferencePickerRegulatoryDocumentsQueryHookResult = ReturnType<typeof useGetRegulatoryReferencePickerRegulatoryDocumentsQuery>;
export type GetRegulatoryReferencePickerRegulatoryDocumentsLazyQueryHookResult = ReturnType<typeof useGetRegulatoryReferencePickerRegulatoryDocumentsLazyQuery>;
export type GetRegulatoryReferencePickerRegulatoryDocumentsQueryResult = Apollo.QueryResult<GetRegulatoryReferencePickerRegulatoryDocumentsQuery, GetRegulatoryReferencePickerRegulatoryDocumentsQueryVariables>;
export const GetAssignSegmentReferencePickerDocumentsDocument = gql`
    query GetAssignSegmentReferencePickerDocuments($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    regulatoryDocuments(
      where: {paragraphs: {some: {keywordAssignments: {any: true, all: {vexClusterAssignments: {any: true, all: {keywordStatus: {in: [ACCEPTED, FINALIZED]}}}}}}}}
      order: [{name: ASC}]
    ) {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useGetAssignSegmentReferencePickerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAssignSegmentReferencePickerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignSegmentReferencePickerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignSegmentReferencePickerDocumentsQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetAssignSegmentReferencePickerDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignSegmentReferencePickerDocumentsQuery, GetAssignSegmentReferencePickerDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignSegmentReferencePickerDocumentsQuery, GetAssignSegmentReferencePickerDocumentsQueryVariables>(GetAssignSegmentReferencePickerDocumentsDocument, options);
      }
export function useGetAssignSegmentReferencePickerDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignSegmentReferencePickerDocumentsQuery, GetAssignSegmentReferencePickerDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignSegmentReferencePickerDocumentsQuery, GetAssignSegmentReferencePickerDocumentsQueryVariables>(GetAssignSegmentReferencePickerDocumentsDocument, options);
        }
export type GetAssignSegmentReferencePickerDocumentsQueryHookResult = ReturnType<typeof useGetAssignSegmentReferencePickerDocumentsQuery>;
export type GetAssignSegmentReferencePickerDocumentsLazyQueryHookResult = ReturnType<typeof useGetAssignSegmentReferencePickerDocumentsLazyQuery>;
export type GetAssignSegmentReferencePickerDocumentsQueryResult = Apollo.QueryResult<GetAssignSegmentReferencePickerDocumentsQuery, GetAssignSegmentReferencePickerDocumentsQueryVariables>;